import { IResponseGetRole, IParamsGetRole } from '~/utils/interface/role';
import axiosClient from './axiosClient';

const url: string = '/api/admin/roles';

const roleApi = {
  getList(params: IParamsGetRole) {
    return axiosClient.get<IResponseGetRole>(url, { params });
  },
};
export default roleApi;
